module.exports = __webpack_public_path__ + "static/media/logo-softexpres.082f726f.png";